
import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import NumberFormat from 'react-number-format'

import './cards.css'
import iconArrowTotales from '../img/iconArrowTotales.svg'
import { Box, CircularProgress, Typography } from '@mui/material'
import { checkValidNumber } from '../../../helpers/general'

const colors = {
    green: '#5CBF66',
    orange: '#F88E2C'
}

export const CardUtilidadR = ({ setOpenTotales }) => {

    const {
        total_utilidad_r,
        margen_utilidad_r,
        separacion_miles,
        separacion_decimales,
        simbolo,
        validacion_estado
    } = useSelector(state => state.ppto.detail)

    const { access } = useSelector(state => state.auth)
    const [showAlert, setShowAlert] = useState(false)

    useEffect(() => {

        setShowAlert(false)
        if (validacion_estado === 'requiere' || validacion_estado === 'por validar' || validacion_estado === 'solicitado') {
            setShowAlert(true)
        }

    }, [validacion_estado])

    return access.a23 ? (
        <div className={`cards-totales-ppto ${showAlert ? 'bg-up-req' : 'bg-fi'}`}>
            {showAlert && <i className="bi bi-exclamation-triangle p-foco-alert" title='Requiere validación'></i>}

            <CircularProgressWithLabel
                value={(margen_utilidad_r ? margen_utilidad_r.toFixed(2) : 0).toString()}
                colors={colors}
                showAlert={showAlert}
            />

            <div className='text-center'>
                <NumberFormat
                    className='items-prices'
                    value={total_utilidad_r || 0}
                    displayType={'text'}
                    thousandSeparator={separacion_miles}
                    decimalSeparator={separacion_decimales}
                    prefix={`${simbolo} `}
                    decimalScale={2}
                    fixedDecimalScale
                />
                <span style={{ fontSize: '13px' }}>Rentabilidad real neta</span>
            </div>

            <img
                style={{ cursor: 'pointer' }}
                src={iconArrowTotales}
                alt="icon"
                onClick={() => setOpenTotales(true)}
            />

        </div>
    ) : <div className='cards-totales-ppto-hide'></div>
}

const CircularProgressWithLabel = (props) => {

    const { value, colors, showAlert } = props

    return (
        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
            <CircularProgress variant="determinate" value={parseInt(value)} size='60px' style={{ color: showAlert ? colors.orange : colors.green }} />
            <Box
                sx={{
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Typography variant="caption" component="div" color="text.secondary" style={{ padding: '20px', color: '#919191' }}>
                    {/* {`${Math.round(checkValidNumber(value))}%`} */}
                    {`${checkValidNumber(value)}%`}
                </Typography>
            </Box>
        </Box>
    );
}